<template>
  <div class="Others8Charts">
    <div class="test-player-wrap">
      <iframe allowfullscreen="true" :src="videoList" frameborder="0" class="videosrc"> </iframe>
    </div>
    <!-- <div class="test-player-wrap">
      <VuePlayerVideo class="my-video-container" :src="videoList"> </VuePlayerVideo>
    </div> -->
  </div>
</template>

<script>
// import { number } from 'echarts';
import VuePlayerVideo from 'vue3-player-video';
import { request } from '../../../common/request';
export default {
  name: 'Others8Charts',
  components: {
    VuePlayerVideo,
  },
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      searchValue: '', // 模糊查询输入的值
      videoList: [], // 视频监控
      currentIndex: 0,
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        if (this.Configuration.isScaling) {
          console.log('scale');
        } else if (this.Configuration.isMoving) {
          console.log('mov');
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    this.getApiDataResByFilterAndResponseQuery();
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.unRegisterDebounceAndThrottle();
    this.$store.commit('setMonitorList', []);
    this.$store.commit('setCurrentMonitor', 0);
    console.log('卸载！！！！！！');
  },
  computed: {
    style() {
      return this.ProjectInfo.Style.componentName;
    },
  },
  methods: {
    getStyle(e = '') {
      let style = {};
      let bool = e == 'title';
      switch (this.style) {
        case 'V1Style':
          style = {};
          if (bool) style['V1StyleTitle'] = true;
          style['V1Style'] = true;
          break;
        case 'V2Style':
          style = {};
          if (bool) style['V2StyleTitle'] = true;
          style['V2Style'] = true;
          break;
        case 'V3Style':
          style = {};
          if (bool) style['V3StyleTitle'] = true;
          style['V3Style'] = true;
          break;
        case 'V4Style':
          style = {};
          if (bool) style['V4StyleTitle'] = true;
          style['V4Style'] = true;
          break;
        case 'V5Style':
          style = {};
          if (bool) style['V5StyleTitle'] = true;
          style['V5Style'] = true;
          break;
        case 'V6Style':
          style = {};
          if (bool) style['V6StyleTitle'] = true;
          style['V6Style'] = true;
          break;
        case 'V7Style':
          style = {};
          if (bool) style['V7StyleTitle'] = true;
          style['V7Style'] = true;
          break;
        case 'V8Style':
          style = {};
          if (bool) style['V8StyleTitle'] = true;
          style['V8Style'] = true;
          break;
        default:
          break;
      }
      return style;
    },
    handleShowMonitor(e, video, index) {
      console.log(e, video, index, 'e, video, index');
      e.stopPropagation();
      e.preventDefault();
      console.log('监控！');
      this.currentIndex = index;
      this.$store.commit('setCurrentMonitor', index);
    },
    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      // clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      clearInterval(this.staticIntervalTaskID2);
      // this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      let grid = {};
      let chartColor = [];
      let source = [];
      let seriesList = [];
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };

      if (this.Configuration.propertyData?.chartsColor?.value?.chartColor) {
        chartColor = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      // if (this.Configuration.propertyData.chartsGrid.value) {
      //   grid = this.Configuration.propertyData.chartsGrid.value;
      // }
      if (ParamData) {
        console.log(ParamData, 'ParamData');
        source = ParamData.source;
        // seriesList = ParamData.seriesList;
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
      }
      // this.data = source;
      console.log(source, 'source');
      console.log(seriesList);
      console.log(chartColor);
      console.log(fontStyle);
      console.log(grid);

      let parking = [];
      // let video = [];
      let video = '';
      function DealData() {
        source.forEach(item => {
          video = item.y;
          // video.push({
          //   title: item.name,
          //   longitude: item.longitude,
          //   latitude: item.latitude,
          //   outsrc: item.outsrc,
          //   icon: 'http://gisapi.xyabcd.com/icon/marker_sp.png', // 覆盖物图标
          //   infowindowshowLink: '1',
          //   infowindowlinkUrl: '',
          //   infowindowImgpath: 'http://bd.likezou.com/',
          //   infowindowiframeUrl: item.outsrc, // 视频流
          //   infowindowData: {
          //     row1: {
          //       编码: item.row_id,
          //       设备来源: item.destination_id,
          //     },
          //     row2: {
          //       中心经度: item.longitude,
          //       中心纬度: item.latitude,
          //     },
          //   },
          // });
        });
      }

      DealData();
      this.videoList = video;
      // this.$store.commit('setMonitorList', video);
      // this.car = parking
      // this.carData = carData
      // console.log('------------------------------------aaaa');
      // console.log(xyData);
      // this.data1.unit = unit;
      // this.data2.unit = unit;
      // this.data3.unit = unit;

      // if (xyData[0]) {
      //   this.data1.name = xyData[0].name;
      //   this.data1.value = xyData[0].value;
      // }
      // if (xyData[1]) {
      //   this.data2.name = xyData[1].name;
      //   this.data2.value = xyData[1].value;
      // }
      // if (xyData[2]) {
      //   this.data3.name = xyData[2].name;
      //   this.data3.value = xyData[2].value;
      // }

      // console.log(unit);
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          let data = this.$_.cloneDeep(ChartsData.staticData);

          this.setEchartsOptions(data);
        };
        clearInterval(this.staticIntervalTaskID);
        func();

        this.staticIntervalTaskID = setInterval(() => {
          console.log('任务执行staticData');
          console.log(chartsAnimation);
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);

        this.staticIntervalTaskID2 = setInterval(() => {
          func();
        }, (chartsAnimation?.staticRefreshIntervalTime - 2 <= 0 ? 1 : chartsAnimation?.staticRefreshIntervalTime - 2) * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
        };
        func();
        this.apiIntervalTaskID = setInterval(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }

        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          let params = ChartsData.apiData.apiPostParams || '{}';
          // this.axios({
          //   method: ChartsData.apiData.apiUrlMethod,
          //   url: ChartsData.apiData.apiUrl,
          //   params: eval('(' + params + ')'),
          //   headers: header,
          // })
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: eval('(' + params + ')'),
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          let params = ChartsData.apiData.apiPostParams || '{}';
          // this.axios({
          //   method: ChartsData.apiData.apiUrlMethod,
          //   url: ChartsData.apiData.apiUrl,
          //   data: eval('(' + params + ')'),
          //   headers: header,
          // })
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            data: eval('(' + params + ')'),
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // console.log('getApiDataResByResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function (data, filter_text) {
          let dataSet = {};
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            // console.log('getApiDataResByFilterAndResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },

  Configuration: {
    componentTitle: '智能监控',
    componentName: 'Others8Charts',
    componentOverViewImg: './img/charts/OthersCharts/Others4Charts.png',
    id: '',
    style: {
      width: 250,
      height: 280,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },

      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts0Border',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://m.cqlpmysblzh.com/gthmmc/index.php?m=amobiletour&c=dataMange&a=queryDataOfResource&pageNo=1&pageNum=999&directory_code=video',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.data',
            isUseFilter: false,
            apiFilter: ``,
            apiUrlMethod: 'get',
            isUseInterval: false,
            apiInterval: 10,
          },
          staticData: {
            seriesList: ['地址'],
            source: [
              {
                s: '地址',
                y: 'https://tb-video.bdstatic.com/tieba-smallvideo-transcode-crf/116931661_eb38c191612950f32dae5f26ddcf0a95_22409283003c_0.mp4?vt=1&pt=3&ver=&cr=2&cd=0&sid=&ft=8&tbau=2024-10-13_ebccf71dc9862bbf72b6124df7fe7b59aac00c78e199c44cd833764012b15fc9&ptid=7637698958',
                x: 'url',
              },
            ],
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 80,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Others8Charts {
  /* background-color: rgba(28, 35, 46, 0.6196078431); */
  /* border-radius: 10px; */
  width: 100%;
  height: 100%;
  /* padding: 20px 10px; */
  position: relative;

  .title {
    font-size: 16px;
    font-weight: bold;
    color: #4ed6f6;

    span {
      line-height: 2;
      font-size: 14px;
      position: relative;
      left: 28px;
      top: 4px;
    }
  }
  .test-player-wrap {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    iframe {
      z-index: 1;
      width: 96%;
      height: 96%;
    }
  }

  .result {
    height: 80%;
    padding: 10px;
    border-radius: 10px;
    margin-top: 10px;

    .videoList {
      /* padding: 6px 0 6px 12px; */

      // min-height: 30px;
      .video {
        &:hover {
          cursor: pointer;
        }

        display: flex;
        align-items: center;

        span {
          &:nth-child(2) {
            color: #fff;
            font-size: 14px;
          }
        }
      }
    }
  }
}

:deep(.el-input__inner) {
  background: none;
  border: 1px solid #357494;
  color: #fff;
}

/* .active {
  background: #1bc4c9;
} */

// 空谷幽兰
.V1Style {
  border-radius: 10px;
  padding: 0;
  background: rgba(46, 46, 46, 0.38);

  .title {
    background: url('/img/styles/titleIcons/youlan_title.png') no-repeat;
    width: 100%;
    color: #fff;
    height: 12%;
    position: absolute;
    margin-top: -12%;
    max-width: 300px;
    min-height: 20px;
  }

  .result {
    height: 80%;
    padding: 10px;
    border-radius: 10px;
    background: none !important;

    .active {
      background: #0a61a8;
    }
  }
}

// 只此青蓝
.V2Style {
  border-radius: 10px;
  padding: 0;
  background: rgba(46, 46, 46, 0.38);

  .title {
    background: url('/img/styles/titleIcons/cyan_title.png') no-repeat;
    width: 100%;
    color: #fff;
    height: 5%;
    position: absolute;
    margin-top: -12%;
    max-width: 312px;
    min-height: 40px;
  }

  .result {
    background: none !important;

    .active {
      background: #2c4c40;
    }
  }
}

// 蔚蓝时代
.V3Style {
  border-radius: 10px;
  padding: 0;
  background: none;

  .title {
    background: url('/img/styles/titleIcons/blue_title.png') no-repeat;
    width: 100%;
    color: #fff;
    height: 5%;
    position: absolute;
    margin-top: -12%;
    max-width: 312px;
    min-height: 40px;

    span {
      line-height: 2;
      font-size: 14px;
      position: relative;
      left: 28px;
      top: 4px;
    }
  }

  .result {
    background: none !important;

    .active {
      background: #0a61a8;
    }
  }
}

// 紫气东来
.V4Style {
  border-radius: 10px;
  padding: 0;
  background: none;

  .title {
    background: url('/img/styles/titleIcons/purple_title.png') no-repeat;
    height: 5%;
    width: 100%;
    color: #fff;
    position: absolute;
    margin-top: -16%;
    max-width: 312px;
    min-height: 40px;
  }

  .result {
    background: none !important;

    .active {
      background: #682f9e;
    }
  }
}

// 绿野仙踪
.V5Style {
  border-radius: 10px;
  padding: 0;
  background: none;

  .title {
    background: url('/img/styles/titleIcons/green_title.png') no-repeat;
    height: 10%;
    color: #fff;
    width: 100%;
    position: absolute;
    margin-top: -16%;
    max-width: 312px;
    min-height: 40px;
  }

  .result {
    .active {
      background: #9fe9a9a2;
    }
  }
}

// 青绿时代
.V6Style {
  border-radius: 10px;
  padding: 0;

  .title {
    height: 10%;
    color: #fff;
    width: 100%;
    position: absolute;
    margin-top: -16%;
    max-width: 312px;
    min-height: 40px;

    span {
      line-height: 4;
    }
  }

  .result {
    .active {
      background: #c2c194;
    }
  }
}

// 蓝色风暴
.V7Style {
  border-radius: 10px;
  padding: 0;
  background: none;

  .title {
    background: url('/img/styles/titleIcons/V7_title.png') no-repeat;
    height: 10%;
    color: #fff;
    width: 96%;
    text-align: center;
    position: absolute;
    margin-top: -16%;
    max-width: 312px;
    min-height: 40px;

    span {
      top: 8px;
      left: 0;
    }
  }

  .result {
    .active {
      background: #0a61a8;
    }
  }
}

// 青云雅韵
.V8Style {
  border-radius: 10px;
  padding: 0;
  background: none;

  .title {
    height: 10%;
    color: #61748a;
    width: 100%;
    position: absolute;
    margin-top: -16%;
    max-width: 312px;
    min-height: 40px;

    span {
      line-height: 4;
    }
  }

  .result {
    background: #fff;

    .videoList .video span {
      color: #000000a2 !important;
    }

    .active {
      background: #000000a2;
    }
  }
}
</style>
